import HomeOnboarding from "features/Home/HomeOnboarding"
import OfferLetterAvailableOnboarding from "features/Home/OfferLetter/PgCTL/OfferLetterAvailableOnboarding"
import {
  PgCTLOfferLetterDialog,
  usePgCTLOfferLetter,
} from "features/Home/OfferLetter/PgCTL/usePgCTLOfferLetter"
import PgCTLWelcomeOnboardingDialog from "features/Home/OfferLetter/PgCTL/WelcomeDialogOnboarding"
import { useSuraasaPlusContext } from "features/SuraasaPlus/context"
import React, { useMemo, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { importantSearchParams } from "utils/constants"

const OnboardingManager = () => {
  const {
    isOfferLetterSent,
    isRegistrationDone,
    hasViewedOfferLetter,
    hasViewedWelcomeModal,
  } = usePgCTLOfferLetter()
  const { isSPNYUser } = useSuraasaPlusContext()
  const [searchParams] = useSearchParams()
  // The offer letter sheet is already being deep-linked open via
  // OfferLetterBanner in this case — don't stack any onboarding on top of
  // it. Captured once on mount (rather than read fresh each render) because
  // OfferLetterBanner strips the param from the URL once the sheet closes,
  // and we don't want that to re-trigger onboarding at that point.
  const [isOfferLetterDeepLinked] = useState(
    () =>
      searchParams.get(importantSearchParams.dialog) ===
      PgCTLOfferLetterDialog.OfferLetter
  )

  const onboardingDialogs = useMemo(() => {
    if (isOfferLetterDeepLinked) return []

    const arr: React.ReactNode[] = []

    if (isRegistrationDone && !hasViewedWelcomeModal) {
      arr.push(
        <PgCTLWelcomeOnboardingDialog key="pgctl-welcome-onboarding-dialog" />
      )
    }

    if (isOfferLetterSent && !hasViewedOfferLetter) {
      arr.push(
        <OfferLetterAvailableOnboarding key="offer-letter-available-dialog" />
      )
    }
    if (isSPNYUser) {
      return []
    }

    if (arr.length === 0) arr.push(<HomeOnboarding key="home-onboarding" />)

    return arr.length > 0 ? [arr[0]] : []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOfferLetterSent, isRegistrationDone, isOfferLetterDeepLinked])

  return (
    <div>
      {onboardingDialogs.map((Dialog, index) => (
        <div key={index}>{Dialog}</div>
      ))}
    </div>
  )
}

export default OnboardingManager
